/**
 * Spins the checkbox of a filter from the moment a shopper picks it until the
 * collection redraws.
 *
 * collection-filters-form.js waits half a second before it even starts fetching, so
 * without this the checkbox sits still while the shopper waits for the grid.
 *
 * The class clears itself: the response replaces the whole sidebar. The timer only
 * covers a request that never lands.
 */
(() => {
  const selectors = {
    sidebar: '[data-collection-sidebar]',
    item: '.sidebar__item',
    checkbox: 'input[type="checkbox"]',
  };

  const classes = {
    loading: 'is-loading',
  };

  const failsafeDelay = 10000;

  document.addEventListener('change', (event) => {
    const checkbox = event.target;

    if (!checkbox.matches || !checkbox.matches(selectors.checkbox) || !checkbox.checked) return;

    const item = checkbox.closest(selectors.item);

    if (!item || !item.closest(selectors.sidebar)) return;

    item.classList.add(classes.loading);

    setTimeout(() => item.classList.remove(classes.loading), failsafeDelay);
  });
})();
